import * as React from "react";
import classnames from "classnames";

import { ColumnProps } from "../../../../../components/DataGrid/CellColumnProps";
import { Getter } from "../../../../../components/DataGrid/DataGrid";
import { Entity } from "../../../../../models/Entity";

const styles = require('./IdColumn.local.css');

const getterId: Getter<Entity> = p => p.id;

interface Props extends ColumnProps
{
    header: string;
    getValue?: (item: any) => any
}

// This column displays the id of a particular entity
// Basically this is a TextColumn with hardcoded text extractor
export class IdColumn extends React.Component<Props, null>
{
    static defaultProps = {
        headerClassName: styles.IdColumn,
        getValue: getterId,
    };
    
    render()
    {
        const { datum, getValue, cellClassName } = this.props;
        return <td className={classnames(cellClassName)} >{getValue(datum)}</td>;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Pages/Columns/IdColumn/IdColumn.tsx